import { StorageManager } from './manager'
import { S3StorageService } from './providers'

/**
 * To work with others providers, create a new provider and replace
 * the S3StorageService (use `S3StorageService` class as a reference)
 */
const storageService = new S3StorageService()
export const storage = new StorageManager(storageService)
